import { UNQUALIFIED_SEGMENTS_KEY } from 'pages/leads/constants';
import * as T from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Link } from '@olist/united';

import UnqualifiedCardFeedback from '../unqualified-card-feedback/unqualified-card-feedback';

const UnqualifiedCardsList = ({ items, qualificationProfile }) => {
  const { t } = useTranslation();

  return items?.length ? (
    <Box width={1} maxWidth="628px" mb={4}>
      {items.map((unqualifiedItem) => {
        const isUnqualifiedSegments = unqualifiedItem.key === UNQUALIFIED_SEGMENTS_KEY;

        return (
          <UnqualifiedCardFeedback
            key={unqualifiedItem.key}
            isUnqualifiedSegments={isUnqualifiedSegments}
            unqualifiedItem={unqualifiedItem}
            qualificationProfile={qualificationProfile}
          />
        );
      })}
    </Box>
  ) : (
    <Box>
      <Link href="https://blog.olist.com/" target="_blank">
        {t`check out the blog`}
      </Link>
    </Box>
  );
};

export default UnqualifiedCardsList;

UnqualifiedCardsList.propTypes = {
  items: T.arrayOf(
    T.shape({
      description: T.node.isRequired,
      icon: T.string.isRequired,
      key: T.string.isRequired,
      labelLink: T.string,
      link: T.string.isRequired,
      title: T.string.isRequired,
    }).isRequired
  ).isRequired,
  qualificationProfile: T.shape({}).isRequired,
};
